import React from "react";
import GrnHeader from "./parts/GrnHeader";
import { compareAsc, format } from "date-fns";
import toWord from "../../../Utility/toWord";
import GrnHeaderTpn from "./parts/GrnHeaderTpn";

const GRNprint = React.forwardRef(({ ...props }, ref) => {
   
  const { grn } = props;
  // console.log(grn);
  let i = 1;
  return (
    <div className="container py-2" ref={ref}>
      {grn?.poNo !== null ? (
        <GrnHeader
          grn={grn}
          title="Goods Receive Note"
          format={format}
          className="mb-5"
        />
      ) : (
        <GrnHeaderTpn
          grn={grn}
          title="Goods Receive Note"
          format={format}
          className="mb-5"
        />
      )}
      {/* <GrnHeader
        grn={grn}
        title="Goods Receive Note"
        format={format}
        className="mb-5"
      /> */}

      <div className="row pt-2">
        <div className="col-12  px-2 ">
          <table className="table ">
            <thead>
              <tr>
                <th scope="col" className="ps-2">
                  #
                </th>
                <th scope="col">Code</th>
                <th scope="col">Name</th>
                <th scope="col">UoM</th>
                <th scope="col">Qty</th>
                <th scope="col">TP</th>
                <th scope="col">VAT</th>
                <th scope="col">Amount</th>
                <th scope="col">MRP</th>
              </tr>
            </thead>
            <tbody>
              {grn?.products ? (
                grn?.products
                  ?.slice()
                  .sort((a, b) => a.order - b.order)
                  .map((item) => (
                    <tr>
                      <th className="ps-2">{i++}</th>
                      <td>{item?.article_code}</td>
                      <td>{item?.name}</td>
                      <td>{item?.unit}</td>
                      <td>{parseFloat(item?.qty).toFixed(2)}</td>
                      <td>{parseFloat(item?.tp).toFixed(2)}</td>
                      <td>
                        {" "}
                        {(item?.qty * 100) / item?.tax !== 0
                          ? parseInt(item?.tax ? item?.tax : 0)
                          : 1}
                      </td>
                      <td>
                        {parseFloat(
                          item?.tp * item?.qty
                          //  +
                          // ((item.qty * 100) / item.tax !== 0
                          //   ? parseInt(item.tax)
                          //   : 1)
                        )?.toFixed(2)}
                      </td>
                      <td>{parseFloat(item?.mrp).toFixed(2)}</td>
                    </tr>
                  ))
              ) : (
                <tr colSpan="9" className="text-center">
                  <th>Sorry! No Product Found</th>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan="" className="text-end">
                  VAT: {grn?.tax ? grn.tax : 0}
                </th>

                {/* {console.log(grn?.shipping_cost)} */}
                <th colSpan="">Shipping: {grn?.shipping_cost}</th>
                <th colSpan="3" className="text-end">
                  Total: {parseFloat(grn?.total).toFixed(2)}
                </th>
                <th colSpan="4" className="text-end">
                  Grand Total:
                  {parseFloat(
                    grn?.total + parseInt(grn?.shipping_cost)
                  ).toFixed(2)}
                </th>
              </tr>
              <tr>
                <td colSpan="9" className="text-start">
                  <i>
                    <b>In Words:</b>{" "}
                    {toWord(
                      Math.round(grn?.total + parseInt(grn?.shipping_cost))
                    )}{" "}
                    Taka Only
                  </i>
                </td>
              </tr>
              <tr>
                <td colSpan="9" className="text-start">
                  <i>
                    {console.log(grn?.note)}
                    <b>Note:</b> {grn?.note}
                  </i>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <br />
      <br />
      <br />
      <div className="row px-2  ">
        <div className="col-4">
          <p>
            <b>Prepared By: </b>
            {grn?.userId?.name}
          </p>
        </div>
        <div className="col-4">
          <p>
            <b>Checked By:</b>
          </p>
        </div>
        <div className="col-4">
          <p>
            <b>Authorized By:</b>
          </p>
        </div>
      </div>
    </div>
  );
});

export default GRNprint;
